import { useToast } from '../components/ui/Toast/ToastProvider';
import { getErrorMessage } from './useCreateProject';

export const useNotifications = () => {
  const { showSuccess, showError, showWarning, showInfo } = useToast();

  const notifySuccess = (operation: string, details?: string) => {
    showSuccess(
      `${operation} Successful!`,
      details
    );
  };

  const notifyError = (operation: string, error: unknown) => {
    const errorMessage = getErrorMessage(error);
    showError(
      `${operation} Failed`,
      errorMessage
    );
  };

  const notifyWarning = (title: string, message?: string) => {
    showWarning(title, message);
  };

  const notifyInfo = (title: string, message?: string) => {
    showInfo(title, message);
  };

  return {
    notifySuccess,
    notifyError,
    notifyWarning,
    notifyInfo,
    // Direct access to toast
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
